import createLeadFieldSelect from "./createLeadFieldSelect";

export default createLeadFieldSelect("/leads/all_current_switch_risks", {
  displayName: "CurrentSwitchRiskSelect",
  defaultPlaceholder: "Select Current Switch Risk",
});
